// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1_7i8","header":"ClearentDisclaimer_header__2SX_8","inner":"ClearentDisclaimer_inner__3SEUO"};